import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section, SignupCard } from 'common/components';
import { RELATED_SERVICES_STORE_NAME, selectActualMeasure } from 'modules/related-services';
import { useStoreon } from 'storeon/react';
import { formatToRub } from 'utils/format';
import { BATHROOM_REPAIR_CDN_PATH, BATHROOM_REPAIR_ELEMENT_BLOCK } from '../../bathroom-repair-constants';

export const BathroomRepairSizing: React.FC = () => {
  const { t } = useTranslation();
  const { relatedServices } = useStoreon(RELATED_SERVICES_STORE_NAME);
  const actualMeasure = selectActualMeasure(relatedServices);
  const title = t('sizing-section.title', { price: formatToRub(actualMeasure?.price) });

  return (
    <Section>
      <SignupCard
        description={t('sizing-section.description') || ''}
        buttonProps={{
          ariaLabel: t('sizing-section.button-title'),
          elementBlock: BATHROOM_REPAIR_ELEMENT_BLOCK,
          elementName: title,
          elementText: t('sizing-section.button-name'),
          href: actualMeasure?.serviceURL,
          label: t('sizing-section.button-name'),
          title: t('sizing-section.button-title') || '',
          rel: 'noreferrer',
          target: '_blank',
        }}
        logo={{
          alt: t('sizing-section.img-alt'),
          src: `${BATHROOM_REPAIR_CDN_PATH}/sizing/sizing.png/sizing.png`,
        }}
        title={title}
      />
    </Section>
  );
};
